module.exports.DEFAULT_LANG = "en-us"
module.exports.LANGUAGES = ["en-us", "ru"]
module.exports.HOME_PAGE_UID = "home-page"
module.exports.SITE_URL = "https://ankocorp.com"
